/** The icon of each source kind (rows, Details, the Sources list). */

import type { SourceKind } from '@digester/core';

export const SOURCE_KIND_ICONS: Readonly<Record<SourceKind, string>> = {
  rss: 'rss',
  email: 'mail',
  youtube: 'circle-play',
  github: 'git-branch',
  telegram: 'send',
  mastodon: 'at-sign',
  bluesky: 'cloud',
  reddit: 'message-square',
  discourse: 'messages-square',
  watcher: 'radio',
};

export const SOURCE_KIND_LABELS: Readonly<Record<SourceKind, string>> = {
  rss: 'RSS',
  email: 'Email',
  youtube: 'YouTube',
  github: 'GitHub',
  telegram: 'Telegram',
  mastodon: 'Mastodon',
  bluesky: 'Bluesky',
  reddit: 'Reddit',
  discourse: 'Discourse',
  watcher: 'Watcher',
};

export function sourceKindIcon(kind: SourceKind): string {
  return SOURCE_KIND_ICONS[kind] ?? 'rss';
}
